const IDS_KEY = "v2.favouriteSchoolIds";
const FILTER_KEY = "v2.favouritesFilterOn";

function readIds() {
  try {
    const raw = sessionStorage.getItem(IDS_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id));
  } catch {
    return [];
  }
}

function writeIds(ids) {
  try {
    sessionStorage.setItem(IDS_KEY, JSON.stringify(ids));
  } catch {
    /* ignore quota / private mode */
  }
}

function readFilterOn() {
  try {
    return sessionStorage.getItem(FILTER_KEY) === "1";
  } catch {
    return false;
  }
}

function writeFilterOn(on) {
  try {
    sessionStorage.setItem(FILTER_KEY, on ? "1" : "0");
  } catch {
    /* ignore */
  }
}

export const favouritesStorage = {
  readIds,
  writeIds,
  readFilterOn,
  writeFilterOn,
};
